import Swiper, {FreeMode} from "swiper"

export default (el) => {
  const swiperEl = el.querySelector('.js-home-boxes')

  new Swiper(swiperEl, {
    modules: [FreeMode],
    slidesPerView: 3.4,
    centerInsufficientSlides: true,
    spaceBetween: 8,
    freeMode: {
      enabled: true,
    },
    breakpoints: {
      1200: {
        slidesPerView: 9.4,
        spaceBetween: 10,
      }
    },
  })
}
